/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function UploadIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "upload", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M19.5 15.5H5.5V19.5H19.5V15.5Z", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M12.5 6.00003V15.5", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M7.5 11L12.5 6.00003L17.5 11", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(UploadIcon);
export default ForwardRef;
//# sourceMappingURL=uploadIcon.js.map